import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
  getCourses, 
  addCourses as postCourses, 
  updateCourses as putCourses, 
  deleteCourses as removeCourses,
  activateDeactivateCourses as activateCourses,
  uploadImages
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchCourseTableColumnNames = createAsyncThunk("courses/fetchTableColumnNames", async (course, thunkAPI) => {
    try {
      const response = await getHeaders(course); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Courses
export const fetchAllCourses = createAsyncThunk("courses/fetchAll", async (course, thunkAPI) => {
    try {
      const response = await getCourses(course); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Course
export const createCourses = createAsyncThunk("courses/add", async (course, thunkAPI) => {  
    try {
        const response = await postCourses(course);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Course
export const updateCourses = createAsyncThunk("courses/update", async (course, thunkAPI) => {
    try {
        const response = await putCourses(course);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Course
export const deleteCourses = createAsyncThunk("courses/delete", async (course, thunkAPI) => {
    try {
        const response = await removeCourses(course);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Active deactive Course 
export const activateDeactivateCourses = createAsyncThunk("courses/activateDeactivate", async (course, thunkAPI) => {
  try {
    const response = await activateCourses(course);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message)
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

export const uploadCourseIcon = createAsyncThunk("courses/icon", async (course, thunkAPI) => {
  try {
    const response = await uploadImages(course); 
    return response.Data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});